import SearchMatchingRuleDetailSection from '../../../sections/AdminDashboard/Configuration/SearchMatchingRuleDetail';

const SearchMatchingRuleDetail = () => <SearchMatchingRuleDetailSection />;

export default SearchMatchingRuleDetail;
